/* Copyright (c) 2022-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import {
  UpdateApiKeyInput,
  useUpdateApiKeyMutation,
} from "~/generated/graphql";
import { showError, showSuccess } from "~/services/toast";
import { generateActionSuccessText } from "~/tools";

type Props = {
  onSuccess: () => void;
};

export function useUpdateApiKey({ onSuccess }: Props) {
  const [updateApiKeyMutation, { client, ...rest }] = useUpdateApiKeyMutation({
    onError: () => {
      showError();
    },
    onCompleted: () => {
      onSuccess();
      showSuccess(generateActionSuccessText("API Key")()("updated")());
    },
  });

  async function updateApiKey(data: UpdateApiKeyInput) {
    await updateApiKeyMutation({
      variables: {
        input: {
          ...data,
        },
      },
    });
  }

  return [updateApiKey, { client, ...rest }] as const;
}
